import { render, staticRenderFns } from "./BackgroundRemoval.vue?vue&type=template&id=77234fb6&scoped=true"
import script from "./BackgroundRemoval.vue?vue&type=script&lang=js"
export * from "./BackgroundRemoval.vue?vue&type=script&lang=js"
import style0 from "./BackgroundRemoval.vue?vue&type=style&index=0&id=77234fb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77234fb6",
  null
  
)

export default component.exports